export default __webpack_public_path__ + "static/media/shakes.af168042.jpg";